/* ==========================================================
   PM Bundles — Kaching-style quantity bundles
   Free-item tiers (Buy X Get Y Free) + in-bundle upsell
   ========================================================== */
(function () {
  if (customElements.get('pm-bundles')) return;

  var UPSELL_MAX_QTY = 10;

  /* ---------- Money formatting ---------- */
  function fallbackMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var decPart = parts[1];
    var noZeros = decPart === '00';

    return (format || '${{amount}}')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, intPart)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, intPart + ',' + decPart)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, intPart)
      .replace(/\{\{\s*amount\s*\}\}/g, noZeros ? intPart : intPart + '.' + decPart);
  }

  function money(cents, format) {
    if (typeof window.formatMoney === 'function') {
      try {
        return window.formatMoney(cents, format, true);
      } catch (e) {
        /* fall through */
      }
    }
    return fallbackMoney(cents, format);
  }

  /* ---------- Component ---------- */
  class PmBundles extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;

      this.sectionId = this.dataset.section;
      this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
      this.useVariants = this.dataset.useVariants === 'true';
      this.showTotal = this.dataset.showTotal === 'true';
      this.unitLabel = this.dataset.unitLabel == null ? '' : this.dataset.unitLabel;
      this.saveLabel = this.dataset.saveLabel == null ? '' : this.dataset.saveLabel;

      var json = this.querySelector('[data-pmb-data]');
      try {
        this.data = JSON.parse(json.textContent);
      } catch (e) {
        this.data = { basePrice: 0, baseCompare: 0, variants: [] };
      }

      this.basePrice = this.data.basePrice;
      this.baseCompare = this.data.baseCompare;

      this.variantMap = {};
      (this.data.variants || []).forEach(
        function (variant) {
          this.variantMap[String(variant.id)] = {
            price: variant.price,
            compare:
              variant.compare_at_price && variant.compare_at_price > variant.price
                ? variant.compare_at_price
                : variant.price,
          };
        }.bind(this)
      );

      this.inputs = Array.prototype.slice.call(this.querySelectorAll('.pmb__input'));
      this.upsellInput = this.querySelector('[data-pmb-upsell]');
      this.upsellSelect = this.querySelector('[data-pmb-upsell-select]');
      this.upsellQtyInput = this.querySelector('[data-pmb-upsell-qty]');

      this.inputs.forEach(
        function (input) {
          input.addEventListener('change', this.onTierChange.bind(this));
        }.bind(this)
      );

      if (this.upsellInput) {
        this.upsellInput.addEventListener('change', this.renderTotal.bind(this));
      }

      Array.prototype.forEach.call(
        this.querySelectorAll('[data-pmb-variant-select]'),
        function (select) {
          select.addEventListener('change', this.render.bind(this));
        }.bind(this)
      );

      if (this.upsellSelect) {
        this.upsellSelect.addEventListener(
          'change',
          function () {
            var el = this.querySelector('[data-pmb-upsell-price]');
            if (el) el.textContent = money(this.upsellPrice(), this.moneyFormat);
            this.renderTotal();
          }.bind(this)
        );
      }

      /* Upsell quantity stepper */
      Array.prototype.forEach.call(
        this.querySelectorAll('[data-pmb-upsell-step]'),
        function (btn) {
          btn.addEventListener(
            'click',
            function (e) {
              e.preventDefault();
              e.stopPropagation();
              if (!this.upsellQtyInput) return;
              var next = this.upsellQty() + parseInt(btn.dataset.pmbUpsellStep, 10);
              this.upsellQtyInput.value = Math.max(1, Math.min(UPSELL_MAX_QTY, next));
              this.renderTotal();
            }.bind(this)
          );
        }.bind(this)
      );

      if (this.upsellQtyInput) {
        this.upsellQtyInput.addEventListener(
          'change',
          function () {
            this.upsellQtyInput.value = this.upsellQty();
            this.renderTotal();
          }.bind(this)
        );
      }

      // Selects and the quantity stepper live inside <label>, so clicks would toggle the radio/checkbox.
      Array.prototype.forEach.call(
        this.querySelectorAll('[data-pmb-variants], [data-pmb-upsell-variants], [data-pmb-upsell-qtywrap]'),
        function (wrap) {
          ['click', 'mousedown', 'touchstart'].forEach(function (evt) {
            wrap.addEventListener(evt, function (e) {
              e.stopPropagation();
            });
          });
          wrap.addEventListener('click', function (e) {
            if (e.target && e.target.tagName === 'INPUT') return;
            e.preventDefault();
          });
        }
      );

      Array.prototype.forEach.call(
        this.querySelectorAll('[data-pmb-variant-select], [data-pmb-upsell-select]'),
        function (select) {
          buildPicker(select);
        }
      );

      this.form = document.getElementById(this.dataset.form);
      this.bindVariantChange();
      this.bindSubmitIntercept();

      this.render();
      this.syncQuantity();
    }

    /* ---------- Selection ---------- */
    get selected() {
      return this.inputs.filter(function (i) {
        return i.checked;
      })[0];
    }

    tierOf(input) {
      return {
        paid: parseInt(input.dataset.paid, 10) || 1,
        free: parseInt(input.dataset.free, 10) || 0,
        total: parseInt(input.dataset.total, 10) || 1,
        discount: parseInt(input.dataset.discount, 10) || 0,
      };
    }

    onTierChange() {
      this.syncQuantity();
      this.renderTotal();
    }

    /* ---------- Upsell ---------- */
    upsellActive() {
      return !!(this.upsellInput && this.upsellInput.checked);
    }

    upsellPrice() {
      if (!this.upsellInput) return 0;
      if (this.upsellSelect) {
        var opt = this.upsellSelect.options[this.upsellSelect.selectedIndex];
        return opt ? parseInt(opt.dataset.price, 10) || 0 : 0;
      }
      return parseInt(this.upsellInput.dataset.price, 10) || 0;
    }

    upsellQty() {
      if (!this.upsellQtyInput) return 1;
      var q = parseInt(this.upsellQtyInput.value, 10) || 1;
      return Math.max(1, Math.min(UPSELL_MAX_QTY, q));
    }

    upsellVariantId() {
      if (this.upsellSelect) return parseInt(this.upsellSelect.value, 10);
      var hidden = this.querySelector('[data-pmb-upsell-id]');
      return hidden ? parseInt(hidden.getAttribute('value'), 10) : null;
    }

    /* ---------- Form quantity ---------- */
    syncQuantity() {
      if (!this.form) return;
      var input = this.selected;
      if (!input) return;

      var tier = this.tierOf(input);
      var qty = this.needsMultiAdd() ? 1 : tier.total;

      var field = this.form.querySelector('input[name="quantity"]:not([type="radio"])');
      if (!field) {
        field = document.createElement('input');
        field.type = 'hidden';
        field.name = 'quantity';
        field.setAttribute('data-pmb-quantity', '');
        this.form.appendChild(field);
      }
      field.value = qty;
    }

    needsMultiAdd() {
      var input = this.selected;
      if (!input) return false;
      if (this.upsellActive()) return true;
      if (this.useVariants) return true;
      return false;
    }

    /* ---------- Variant change from the theme ---------- */
    bindVariantChange() {
      var handler = function (payload) {
        var variant =
          payload && payload.data && payload.data.variant ? payload.data.variant : null;
        if (!variant) return;
        if (payload.data.sectionId && payload.data.sectionId !== this.sectionId) return;
        this.applyBase(variant);
      }.bind(this);

      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
        this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.variantChange, handler);
      }

      // Fallback: watch the hidden variant id input
      if (this.form) {
        var idInput = this.form.querySelector('input[name="id"]');
        if (idInput) {
          this.lastId = idInput.value;
          this.poll = setInterval(
            function () {
              if (idInput.value === this.lastId) return;
              this.lastId = idInput.value;
              var v = (this.data.variants || []).filter(function (x) {
                return String(x.id) === String(idInput.value);
              })[0];
              if (v) this.applyBase(v);
            }.bind(this),
            500
          );
        }
      }
    }

    applyBase(variant) {
      this.basePrice = variant.price;
      this.baseCompare =
        variant.compare_at_price && variant.compare_at_price > variant.price
          ? variant.compare_at_price
          : variant.price;
      this.render();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
      if (this.poll) clearInterval(this.poll);
    }

    /* ---------- Price rendering ---------- */
    /* Prices of the variants actually chosen in this tier's pickers.
       Returns null when per-unit pickers are not in use. */
    chosen(card) {
      if (!this.useVariants || !card) return null;
      var selects = Array.prototype.slice.call(
        card.querySelectorAll('[data-pmb-variant-select]')
      );
      if (!selects.length) return null;

      var rows = selects.map(
        function (select) {
          var info = this.variantMap[String(select.value)];
          if (info) return info;
          return { price: this.basePrice, compare: this.baseCompare };
        }.bind(this)
      );
      return rows;
    }

    /* Shopify's Buy X Get Y discounts the cheapest eligible items,
       so the free slots are taken off the lowest prices. */
    tierPrice(tier, card) {
      var rows = this.chosen(card);
      var subtotal;

      if (rows) {
        var prices = rows
          .map(function (r) {
            return r.price;
          })
          .sort(function (a, b) {
            return a - b;
          });
        var sum = prices.reduce(function (a, b) {
          return a + b;
        }, 0);
        var freeSum = prices.slice(0, tier.free).reduce(function (a, b) {
          return a + b;
        }, 0);
        subtotal = sum - freeSum;
      } else {
        subtotal = this.basePrice * tier.paid;
      }

      return Math.round((subtotal * (100 - tier.discount)) / 100);
    }

    tierCompare(tier, card) {
      var rows = this.chosen(card);
      if (rows) {
        return rows.reduce(function (a, r) {
          return a + r.compare;
        }, 0);
      }
      return this.baseCompare * tier.total;
    }

    render() {
      this.inputs.forEach(
        function (input) {
          var tier = this.tierOf(input);
          var card = input.nextElementSibling;
          if (!card) return;

          var price = this.tierPrice(tier, card);
          var compare = this.tierCompare(tier, card);
          var saving = compare - price;
          var unit = Math.round(price / tier.total);

          var priceEl = card.querySelector('[data-pmb-price]');
          if (priceEl) priceEl.textContent = money(price, this.moneyFormat);

          var compareEl = card.querySelector('[data-pmb-compare]');
          if (compareEl) {
            if (compare > price) {
              compareEl.textContent = money(compare, this.moneyFormat);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }

          var unitEl = card.querySelector('[data-pmb-unit]');
          if (unitEl) {
            if (this.unitLabel.trim()) {
              unitEl.textContent = this.unitLabel.replace('[price]', money(unit, this.moneyFormat));
              unitEl.style.display = '';
            } else {
              unitEl.textContent = '';
              unitEl.style.display = 'none';
            }
          }

          var saveEl = card.querySelector('[data-pmb-save]');
          if (saveEl) {
            if (saving > 0 && this.saveLabel.trim()) {
              saveEl.textContent = this.saveLabel
                .replace('[amount]', money(saving, this.moneyFormat))
                .replace('[percent]', tier.discount);
              saveEl.style.display = '';
            } else {
              saveEl.style.display = 'none';
            }
          }
        }.bind(this)
      );

      this.renderTotal();
    }

    renderTotal() {
      this.syncQuantity();
      if (!this.showTotal) return;

      var el = this.querySelector('[data-pmb-total]');
      if (!el) return;

      var input = this.selected;
      if (!input) return;

      var tier = this.tierOf(input);
      var card = input.nextElementSibling;
      var price = this.tierPrice(tier, card);
      var compare = this.tierCompare(tier, card);

      if (this.upsellActive()) {
        var upsellTotal = this.upsellPrice() * this.upsellQty();
        price += upsellTotal;
        compare += upsellTotal;
      }

      var html = '';
      if (compare > price) html += '<s>' + money(compare, this.moneyFormat) + '</s>';
      html += money(price, this.moneyFormat);
      el.innerHTML = html;
    }

    /* ---------- Multi-item add to cart ---------- */
    bindSubmitIntercept() {
      document.addEventListener(
        'submit',
        function (event) {
          if (event.target !== this.form) return;
          if (!this.needsMultiAdd()) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          this.addBundleToCart(event.submitter);
        }.bind(this),
        true
      );
    }

    buildItems() {
      var input = this.selected;
      if (!input) return [];

      var tier = this.tierOf(input);
      var card = input.nextElementSibling;
      var items = [];

      var selects =
        this.useVariants && card
          ? Array.prototype.slice.call(card.querySelectorAll('[data-pmb-variant-select]'))
          : [];

      if (selects.length) {
        var counts = {};
        selects.forEach(function (select) {
          counts[select.value] = (counts[select.value] || 0) + 1;
        });
        Object.keys(counts).forEach(function (id) {
          items.push({ id: parseInt(id, 10), quantity: counts[id] });
        });
      } else {
        var idInput = this.form ? this.form.querySelector('input[name="id"]') : null;
        var vid = idInput ? parseInt(idInput.value, 10) : this.data.variantId;
        items.push({ id: vid, quantity: tier.total });
      }

      if (this.upsellActive()) {
        var uid = this.upsellVariantId();
        if (uid) items.push({ id: uid, quantity: this.upsellQty() });
      }

      return items;
    }

    addBundleToCart(submitter) {
      var items = this.buildItems();
      if (!items.length) return;

      var button = submitter || this.form.querySelector('[type="submit"]');
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('loading');
      }

      var drawer = document.querySelector('cart-drawer');
      var body = { items: items };
      if (drawer) {
        body.sections = ['cart-drawer', 'cart-icon-bubble'];
        body.sections_url = window.location.pathname;
      }

      fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then(function (r) {
          return r.json();
        })
        .then(
          function (response) {
            if (response.status) {
              this.showError(response.description || response.message);
              return;
            }

            if (drawer && typeof drawer.renderContents === 'function') {
              drawer.classList.remove('is-empty');
              var innerEl = drawer.querySelector('.drawer__inner');
              if (innerEl) innerEl.classList.remove('is-empty');
              drawer.renderContents(response);
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }

            if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
              window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'pm-bundles' });
            }
          }.bind(this)
        )
        .catch(
          function () {
            this.showError('Something went wrong. Please try again.');
          }.bind(this)
        )
        .finally(function () {
          if (button) {
            button.removeAttribute('aria-busy');
            button.classList.remove('loading');
          }
        });
    }

    showError(message) {
      var host = this.form ? this.form.closest('product-form') : null;
      var wrapper = host ? host.querySelector('.product-form__error-message-wrapper') : null;
      if (!wrapper) {
        alert(message);
        return;
      }
      wrapper.removeAttribute('hidden');
      var target = wrapper.querySelector('.product-form__error-message');
      if (target) target.textContent = message;
    }
  }


  /* ==========================================================
     Image picker — a thumbnail dropdown layered over a native
     <select>. The select stays in the DOM as the source of
     truth, so every other part of this file keeps working.
     ========================================================== */
  function buildPicker(select) {
    if (select.dataset.pmbPicked === 'true') return;
    select.dataset.pmbPicked = 'true';

    var wrap = document.createElement('span');
    wrap.className = 'pmb__picker';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pmb__picker-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');

    var thumb = document.createElement('span');
    thumb.className = 'pmb__picker-thumb';
    var label = document.createElement('span');
    label.className = 'pmb__picker-label';
    var caret = document.createElement('span');
    caret.className = 'pmb__picker-caret';
    btn.appendChild(thumb);
    btn.appendChild(label);
    btn.appendChild(caret);

    var panel = document.createElement('span');
    panel.className = 'pmb__picker-panel';
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;

    function sync() {
      var opt = select.options[select.selectedIndex];
      if (!opt) return;
      var img = opt.getAttribute('data-image');
      thumb.innerHTML = img ? '<img src="' + img + '" alt="" loading="lazy">' : '';
      label.textContent = opt.textContent.trim();
      Array.prototype.forEach.call(panel.children, function (row) {
        var on = row.getAttribute('data-value') === select.value;
        row.classList.toggle('is-selected', on);
        row.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    }

    Array.prototype.forEach.call(select.options, function (opt) {
      var row = document.createElement('button');
      row.type = 'button';
      row.className = 'pmb__picker-opt';
      row.setAttribute('data-value', opt.value);
      row.setAttribute('role', 'option');
      if (opt.disabled) row.classList.add('is-disabled');

      var img = opt.getAttribute('data-image');
      row.innerHTML =
        '<span class="pmb__picker-thumb">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '</span><span class="pmb__picker-label">' +
        opt.textContent.trim() +
        '</span>';

      row.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (opt.disabled) return;
        select.value = opt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        close();
      });

      panel.appendChild(row);
    });

    function open() {
      closeAll();
      panel.hidden = false;
      wrap.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      panel.hidden = true;
      wrap.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (panel.hidden) open();
      else close();
    });

    select.addEventListener('change', sync);

    wrap.appendChild(btn);
    wrap.appendChild(panel);
    select.parentNode.insertBefore(wrap, select);
    select.classList.add('pmb__select-native');
    wrap.appendChild(select);

    sync();
  }

  function closeAll() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.pmb__picker.is-open'),
      function (w) {
        w.classList.remove('is-open');
        var p = w.querySelector('.pmb__picker-panel');
        if (p) p.hidden = true;
        var b = w.querySelector('.pmb__picker-btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    );
  }

  document.addEventListener('click', closeAll);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  customElements.define('pm-bundles', PmBundles);
})();